import React from 'react';
import styles from './styles.module.css';
type Props = {
  children: React.ReactNode;
};

export const EmptyDiv = ({ children }: Props) => {
  return <div className={styles.emptyDiv}>{children}</div>;
};

export default EmptyDiv;
